/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CurateSearchComponent } from './curate-search.component';
import { SysqueSelectBoxModule } from '../../../../../../../shared/ui/src/lib/components/sysque-select-box';
import { DxButtonModule, DxTooltipModule } from 'devextreme-angular';

@NgModule({
  declarations: [CurateSearchComponent],
  imports: [CommonModule, SysqueSelectBoxModule, DxTooltipModule, DxButtonModule],
  exports: [CurateSearchComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CurateSearchModule {}
